import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import SmoothScroll from "@/lib/SmoothScroll";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Consultation from "@/pages/Consultation";
import Quiz from "@/pages/Quiz";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Checkout from "@/pages/Checkout";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SiteLayout = ({ children }) => (
  <>
    <Navbar />
    <CartDrawer />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <SmoothScroll>
              <ScrollTop />
              <Toaster position="bottom-right" theme="dark" />
              <MotionConfig reducedMotion="user">
              <Routes>
                <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
                <Route path="/shop" element={<SiteLayout><Shop /></SiteLayout>} />
                <Route path="/product/:slug" element={<SiteLayout><ProductDetail /></SiteLayout>} />
                <Route path="/consultation" element={<SiteLayout><Consultation /></SiteLayout>} />
                <Route path="/analysis" element={<SiteLayout><Quiz /></SiteLayout>} />
                <Route path="/blog" element={<SiteLayout><Blog /></SiteLayout>} />
                <Route path="/blog/:slug" element={<SiteLayout><BlogPost /></SiteLayout>} />
                <Route path="/checkout" element={<SiteLayout><Checkout /></SiteLayout>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
              </MotionConfig>
            </SmoothScroll>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
